(function () {
  const IG_ICON = `
    <svg class="icon icon-instagram" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path fill="currentColor" fill-rule="evenodd" d="M13.23 3.492c-.84-.037-1.096-.046-3.23-.046-2.144 0-2.39.01-3.238.055-.776.027-1.195.164-1.487.273a2.4 2.4 0 0 0-.912.593 2.5 2.5 0 0 0-.602.922c-.11.282-.238.702-.274 1.486-.046.84-.046 1.095-.046 3.23s.01 2.39.046 3.229c.004.51.097 1.016.274 1.495.145.365.319.639.602.913.282.282.538.456.92.602.474.176.974.268 1.479.273.848.046 1.103.046 3.238.046s2.39-.01 3.23-.046c.784-.036 1.203-.164 1.486-.273.374-.146.648-.329.921-.602.283-.283.447-.548.602-.922.177-.476.27-.979.274-1.486.037-.84.046-1.095.046-3.23s-.01-2.39-.055-3.229c-.027-.784-.164-1.204-.274-1.495a2.4 2.4 0 0 0-.593-.913 2.6 2.6 0 0 0-.92-.602c-.284-.11-.703-.237-1.488-.273ZM6.697 2.05c.857-.036 1.131-.045 3.302-.045a63 63 0 0 1 3.302.045c.664.014 1.321.14 1.943.374a4 4 0 0 1 1.414.922c.41.397.728.88.93 1.414.23.622.354 1.279.365 1.942C18 7.56 18 7.824 18 10.005c0 2.17-.01 2.444-.046 3.292-.036.858-.173 1.442-.374 1.943-.2.53-.474.976-.92 1.423a3.9 3.9 0 0 1-1.415.922c-.51.191-1.095.337-1.943.374-.857.036-1.122.045-3.302.045-2.171 0-2.445-.009-3.302-.055-.849-.027-1.432-.164-1.943-.364a4.15 4.15 0 0 1-1.414-.922 4.1 4.1 0 0 1-.93-1.423c-.183-.51-.329-1.085-.365-1.943C2.009 12.45 2 12.167 2 10.004c0-2.161 0-2.435.055-3.302.027-.848.164-1.432.365-1.942a4.4 4.4 0 0 1 .92-1.414 4.2 4.2 0 0 1 1.415-.93c.51-.183 1.094-.33 1.943-.366Zm.427 4.806a4.105 4.105 0 1 1 5.805 5.805 4.105 4.105 0 0 1-5.805-5.805m1.882 5.371a2.668 2.668 0 1 0 2.042-4.93 2.668 2.668 0 0 0-2.042 4.93m5.922-5.942a.958.958 0 1 1-1.355-1.355.958.958 0 0 1 1.355 1.355" clip-rule="evenodd"/>
    </svg>
  `;

  function parseAssetMap(root) {
    const el = root.querySelector('[data-zi-community-assets]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function resolveImage(post, assetMap) {
    if (post.image_asset && assetMap[post.image_asset]) {
      return assetMap[post.image_asset];
    }
    return post.image_remote || '';
  }

  function renderGrid(root, posts, assetMap) {
    const grid = root.querySelector('[data-zi-community-grid]');
    const status = root.querySelector('[data-zi-community-status]');
    if (!grid) return;

    const items = posts.slice(0, 8);
    if (!items.length) {
      if (status) {
        status.hidden = false;
        status.textContent = 'No Instagram posts available yet.';
      }
      return;
    }

    grid.innerHTML = items
      .map(function (post, index) {
        const src = resolveImage(post, assetMap);
        const href = post.permalink || '#';
        const alt = (post.alt || 'Instagram post ' + (index + 1)).replace(/"/g, '&quot;');
        return (
          '<li class="zi-community__item">' +
          '<a class="zi-community__link" href="' +
          href +
          '" target="_blank" rel="noopener noreferrer" aria-label="View Instagram post">' +
          '<img class="zi-community__img" src="' +
          src +
          '" alt="' +
          alt +
          '" width="640" height="640" loading="lazy" decoding="async">' +
          '<span class="zi-community__overlay" aria-hidden="true">' +
          '<span class="zi-community__icon">' +
          IG_ICON +
          '</span>' +
          '</span>' +
          '</a>' +
          '</li>'
        );
      })
      .join('');

    if (status) status.hidden = true;
  }

  async function init(root) {
    const feedUrl = root.getAttribute('data-feed-url');
    const assetMap = parseAssetMap(root);
    const status = root.querySelector('[data-zi-community-status]');

    if (!feedUrl) {
      if (status) {
        status.hidden = false;
        status.textContent = 'Instagram feed is not configured.';
      }
      return;
    }

    try {
      const res = await fetch(feedUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Feed request failed');
      const data = await res.json();
      renderGrid(root, data.posts || [], assetMap);
    } catch (err) {
      if (status) {
        status.hidden = false;
        status.textContent = 'Unable to load Instagram posts.';
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-zi-community]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-zi-community]');
    if (root) init(root);
  });
})();
